import { CalendarType } from '@lmt/shared-types';
import {
  Button,
  ButtonColor,
  ButtonWidth,
} from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import { add } from 'date-fns';
import React, { FC } from 'react';

import styles from '@lmt/unicorn-shared/app/components/calendar/change-date/ChangeDateControl.module.scss';
import ArrowLeftIcon from '@lmt/unicorn-shared/app/icons/arrow-left-grey.svg?react';
import ArrowRightIcon from '@lmt/unicorn-shared/app/icons/arrow-right-grey.svg?react';

enum MoveDirection {
  Back,
  Forward,
  Today,
}

interface Props {
  currentDay: Date;
  setCurrentDay: (day: Date) => void;
  calendarType: CalendarType;
}

export const ChangeDateControl: FC<Props> = React.memo(
  function ChangeDateControl(props) {
    const i18next = useScopedTranslation('calendar');
    const { currentDay, setCurrentDay, calendarType } = props;

    const changeDate = (direction: MoveDirection) => {
      switch (direction) {
        case MoveDirection.Today: {
          setCurrentDay(new Date());
          break;
        }
        case MoveDirection.Back:
        case MoveDirection.Forward: {
          const addValue = direction === MoveDirection.Forward ? 1 : -1;
          switch (calendarType) {
            case CalendarType.Day: {
              setCurrentDay(add(currentDay, { days: addValue }));
              break;
            }
            case CalendarType.Week: {
              setCurrentDay(add(currentDay, { weeks: addValue }));
              break;
            }
            case CalendarType.Month: {
              setCurrentDay(add(currentDay, { months: addValue }));
              break;
            }
          }
          break;
        }
      }
    };

    return (
      <div className={styles.container}>
        <Button
          testId={'left-arrow'}
          iconComponent={<ArrowLeftIcon />}
          className={styles.arrowButton}
          color={ButtonColor.Primary}
          width={ButtonWidth.Fullwidth}
          onClick={() => changeDate(MoveDirection.Back)}
        />
        <Button
          testId={'today'}
          title={i18next.t('main.move_today_button')}
          className={styles.todayButton}
          color={ButtonColor.Primary}
          width={ButtonWidth.Fullwidth}
          onClick={() => changeDate(MoveDirection.Today)}
        />
        <Button
          testId={'right-arrow'}
          iconComponent={<ArrowRightIcon />}
          className={styles.arrowButton}
          color={ButtonColor.Primary}
          width={ButtonWidth.Fullwidth}
          onClick={() => changeDate(MoveDirection.Forward)}
        />
      </div>
    );
  },
);
